import React from "react"
import { findField } from "@app/utils/form"
import { useFormikContext } from "formik"
import { useRouteLoaderData } from "react-router-dom"

/**
 * Patch field type of danger inputs to dangerSelect
 *
 * @param currentFieldsets
 * @returns {{fieldsets: *}}
 */
export const useDangerFieldsObserver = (currentFieldsets) => {
	const { values } = useFormikContext()
	// patch fields to element type "dangerSelect"
	const physicalField = findField(currentFieldsets, "physischegefaehrdungsanalyse_gefaehrdungstyp_physische_gefaehrdung")
	const influencesField = findField(currentFieldsets, "physischegefaehrdungsanalyse_gefaehrdungstyp_einflussamtaetigkeitsort")
	const hazardousField = findField(currentFieldsets, "physischegefaehrdungsanalyse_gefaehrdungstyp_gefahrenstoff")
	const { measuresByInfluence = {} } = useRouteLoaderData("root") || {}

	let res = React.useMemo(() => {
		if (physicalField) {
			physicalField.elementType = "dangerSelect"
			physicalField.showAsHeader = true
		}
		if (influencesField) {
			influencesField.elementType = "dangerSelect"
			influencesField.showAsHeader = true
			influencesField.options = Object.keys(measuresByInfluence).map(infl => ({
				value: infl,
				label: infl,
			}))
		}
		return {
			fieldsets: [...currentFieldsets]
		}
	}, [currentFieldsets])

	const categoryValue = values.physischegefaehrdungsanalyse_kategorie_kategorie

	res = React.useMemo(() => {
		if (influencesField && physicalField && hazardousField) {
			if (categoryValue === "physische_gefährdung") {
				physicalField.validation.required = true
				influencesField.validation.required = false
				hazardousField.validation.required = false
			} else if (categoryValue === "einfluss_am_tätigkeitsort") {
				physicalField.validation.required = false
				influencesField.validation.required = true
				hazardousField.validation.required = false
			} else if (categoryValue === "gefahrenstoff") {
				physicalField.validation.required = false
				influencesField.validation.required = false
				hazardousField.validation.required = true
			}
		}

		return {
			fieldsets: [...currentFieldsets]
		}
	}, [categoryValue, currentFieldsets])

	return res
}
